import { Box } from '@mui/material';
import { getAvailableBusinessForFund } from 'lib/api/multiverse/fund';
import { AvailableBusiness } from 'lib/api/multiverse/fund/types';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTable, { Header } from 'lib/designSystem/Table';
import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ClientDialog from './ClientDialog';

export type RowBusiness = Omit<AvailableBusiness, 'id'> & { id: string };

const Accounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [business, setBusiness] = useState<RowBusiness | undefined>(undefined);
  const { data, isPending } = getAvailableBusinessForFund(dispatch);

  const headers: Header[] = [
    { key: 'businessName', label: 'Cliente' },
    { key: 'businessIdentifier', label: 'Rut' },
    { key: 'active', label: 'SII', type: 'sii-connection-temporary' },
    //{ key: 'companyName', label: 'Compartido por' },
    { key: 'expiresAt', label: 'Compartido hasta', type: 'date' },
    {
      key: 'isFinanceCompany',
      label: 'Tipo',
      type: 'is-finance-company',
    },
  ];

  const rows: RowBusiness[] = useMemo(
    () =>
      (data || []).map((x: AvailableBusiness) => ({
        ...x,
        id: `${x.companyId}|${x.businessIdentifier}|${x.businessName}|${x.isFinanceCompany}`,
      })),
    [data],
  );

  if (isPending) return <CenteredCircularProgress type="layout" />;

  const handleClickRow = (encodedId: string) => {
    const [companyId, businessIdentifier, businessName, isFinanceCompany] =
      String(encodedId).split('|');
    if (isFinanceCompany === 'false') {
      const business = rows.find(
        (x: RowBusiness) => x.businessIdentifier === businessIdentifier,
      );
      if (!business) return;
      setBusiness(business);
      setOpen(true);
      return;
    }
    const url = `/funds/business/${companyId}/${businessIdentifier}/summary?businessName=${encodeURIComponent(businessName)}`;
    navigate(url);
  };

  return (
    <>
      <Box mt={2}>
        <EnhancedTable
          data={rows}
          dataHeaders={headers}
          rowsPerPageDefault={25}
          showActions
          handleClickRow={handleClickRow}
        />
      </Box>
      <ClientDialog
        open={open}
        onClose={() => setOpen(false)}
        business={business}
      />
    </>
  );
};

export default Accounts;
